<template>
  <div class="rank-content" style="background-color:#F7F8FA;padding-bottom: 50px;">
    <div class="banner">
      <img src="../../assets/imgs/rank-banner.png" />
    </div>
    <div class="layout-cont">
      <el-tabs v-model="type" type="border-card" @tab-click="handleClick" stretch class="rank-tabs">
        <el-tab-pane label="日榜" name="day" class="t-day active">
          <span slot="label">
            <i></i>日榜
          </span>
        </el-tab-pane>
        <el-tab-pane label="周榜" name="week" class="t-week">
          <span slot="label">
            <i></i>周榜
          </span>
        </el-tab-pane>
        <el-tab-pane label="总榜" name="all" class="t-all bl">
          <span slot="label">
            <i></i>总榜
          </span>
        </el-tab-pane>
      </el-tabs>
      <div class="cont">
        <div id="rank_center">
          <div class="d-bInfo clearfix" v-if="isLogin">
            <dl class="clearfix">
              <dt>
                <a target="_blank">
                  <img :src="user.avatar?user.avatar:defaultAvatar" class="i-img" />
                </a>
              </dt>
              <dd>
                <h5>
                  <strong>{{user.name}}</strong>
                  {{user.position?'在排行榜第'+user.position+'名':'暂未上榜'}}
                </h5>
                <p>
                  您已累计通过了
                  <span>{{user.count}}</span>
                  活动，继续加油
                </p>
              </dd>
            </dl>
            <router-link :to="{name:'training'}" class="quick_study">开始训练</router-link>
            <div style="clear:both;"></div>
          </div>
          <div class="top-3 clearfix">
            <div class="tops" v-for="(item,index) in highList" :key="index">
              <i></i>
              <a target="_blank">
                <img :src="user.avatar?user.avatar:defaultAvatar" class="uImg lazy" style="display: block;" />
              </a>
              <a class="vip new-vip-icon base-vip-icon circle" title="全站通VIP" href target="_blank"></a>
              <div class="before">
                NO.
                <strong>{{item.sort}}</strong>
              </div>
              <span>
                <strong v-if="item.sort===1">鹿状元</strong>
                <strong v-else-if="item.sort===2">鹿榜眼</strong>
                <strong v-else-if="item.sort===3">鹿探花</strong>
                <i></i>
              </span>
              <div class="u-name">{{item.name}}</div>
              <div class="u-time">已通过{{item.count}}活动</div>
            </div>

          </div>
        </div>
        <div class="list-c">
          <div class="list list-th">
            <div class="list1">排行</div>
            <div class="list2">用户名</div>
            <div class="list3">已通过活动数</div>
          </div>
          <div class="list" :class="`num`+item.sort" v-for="(item,index) in tableData" :key="index">
            <div class="list1">
              <div class="list-num">{{item.sort>3?item.sort:''}}</div>
            </div>
            <div class="list2">
              <img :src="item.avatar?item.avatar:defaultAvatar" class="u-Img lazy" style="display: block;" />
              <div class="u-Name">{{item.name}}</div>
            </div>
            <div class="list3">
              <div class="u-Time">
                <strong>{{item.count}}</strong>个
              </div>
            </div>
          </div>
          <div v-if="!list.length" class="no-data">
            暂无数据
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="totalCount"
          :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken, removeToken } from "@/utils/auth";
import { getTrainingRankList } from "@/api/competition";
export default {
  data() {
    return {
      defaultAvatar: require("../../assets/imgs/u326.svg"),
      type: "day",
      isLogin: false,
      user: [],
      list: [],
      highList: [],//排行榜前三名
      pageSize: 10,//默认的请求pageSize = 10
      paginationShow: false,//是否显示分页
      totalCount: 0,//总条数
      currentPage: 1, //设置当前页默认为1
      tableData: [],
    };
  },
  watch: {
    type() {
      this.user = [];
      this.initData()
    },
    currentPage() {
      this.tableData = []
      this.tableData = this.list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    }
  },
  created() {
    this.initData()
    this.isLogin = getToken() ? true : false;
  },
  methods: {
    handleClick(tab, event) {
    },
    initData() {
      let params = {
        type: this.type,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      getTrainingRankList(params).then(response => {
        this.user = response.user
        this.list = response.data
        this.totalCount = response.data.length;
        this.tableData = this.changeData();
        this.highList = response.data.slice(0, 3);
      })
    },
    changeData() {
      return this.list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    },

    //点击下一页和点击页码时执行
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.initData(),
    },
  },
  components: {}
};
</script>

<style scoped>
.banner {
  width: 100%;
  /* height: 300px; */
  text-align: center;
}
.banner img {
  width: 100%;
  /* height: 300px; */
}
.layout-cont {
  width: 1000px;
  margin: 0 auto;
}

.layout-cont .cont {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 7px 0 rgba(135, 148, 161, 0.06);
  padding: 30px 35px;
  position: relative;
  z-index: 1;
}

.layout-cont .top-3 {
  width: 100%;
}

.layout-cont .top-3 .tops {
  width: 294px;
  height: 212px;
  float: left;
  margin: 27px 24px 32px 0;
  border-radius: 5px;
  position: relative;
}

.layout-cont .top-3 .tops .new-vip-icon.base-vip-icon.circle {
  background-position: -751px -47px;
}

.layout-cont .top-3 .tops .new-vip-icon {
  background: url(../../assets/imgs/base-icon.v65.png);
  width: 16px;
  height: 16px;
  display: inline-block;
  z-index: 1;
}

.layout-cont .top-3 .tops:first-child {
  background: -webkit-linear-gradient(111deg, #ff5741, #ffb245);
  background: -moz-linear-gradient(111deg, #ff5741, #ffb245);
  background: -o-linear-gradient(111deg, #ff5741, #ffb245);
  background: linear-gradient(111deg, #ff5741, #ffb245);
}

.layout-cont .top-3 .tops:nth-child(2) {
  background: -webkit-linear-gradient(111deg, #510efd, #0ee9fd);
  background: -moz-linear-gradient(111deg, #510efd, #0ee9fd);
  background: -o-linear-gradient(111deg, #510efd, #0ee9fd);
  background: linear-gradient(111deg, #510efd, #0ee9fd);
}

.layout-cont .top-3 .tops:last-child {
  margin-right: 0;
  background: -webkit-linear-gradient(111deg, #b75aff, #f38dff);
  background: -moz-linear-gradient(111deg, #b75aff, #f38dff);
  background: -o-linear-gradient(111deg, #b75aff, #f38dff);
  background: linear-gradient(111deg, #b75aff, #f38dff);
}

.layout-cont .top-3 .tops:before {
  font-size: 77px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  color: #fff;
  opacity: 0.1;
  text-align: center;
  position: absolute;
  top: 0;
  left: 18px;
}

.layout-cont .top-3 .tops:nth-child(1):before {
  content: "NO.1";
}

.layout-cont .top-3 .tops:nth-child(2):before {
  content: "NO.2";
}

.layout-cont .top-3 .tops:nth-child(3):before {
  content: "NO.3";
}

.layout-cont .top-3 .tops > i {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
}

.layout-cont .top-3 .tops > i:after,
.layout-cont .top-3 .tops > i:before {
  content: "";
  width: 220px;
  height: 220px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  position: absolute;
}

.layout-cont .top-3 .tops > i:before {
  right: -110px;
  bottom: -110px;
}

.layout-cont .top-3 .tops > i:after {
  right: -65px;
  bottom: 70px;
}

.layout-cont .top-3 .tops a .uImg {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 5px solid #fff;
  position: absolute;
  top: -27px;
  right: 20px;
}

.layout-cont .top-3 .tops .vip {
  width: 16px;
  height: 16px;
  position: absolute;
  border: 3px #fff solid;
  border-radius: 50%;
  top: 50px;
  right: 25px;
}

.layout-cont .top-3 .tops .novip {
  display: block;
  width: 23px;
  height: 23px;
  position: absolute;
  top: 67px;
  right: 47px;
  background-image: url(../../assets/imgs/rank-icon.png);
  background-position: -113px -35px;
}

.layout-cont .top-3 .tops .before {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 28px;
  left: 28px;
}

.layout-cont .top-3 .tops .before strong {
  font-size: 40px;
  font-weight: 700;
}

.layout-cont .top-3 .tops > span {
  display: block;
  width: 100%;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  padding: 72px 0 0 28px;
}

.layout-cont .top-3 .tops > span i {
  width: 13px;
  height: 28px;
  background-image: url(../../assets/imgs/rank-icon.png);
  display: inline-block;
  vertical-align: -7px;
}

.layout-cont .top-3 .tops:nth-child(1) > span i {
  background-position: -89px 0;
}

.layout-cont .top-3 .tops:nth-child(2) > span i {
  background-position: -151px 0;
}

.layout-cont .top-3 .tops:nth-child(3) > span i {
  background-position: -214px 0;
}

.layout-cont .top-3 .tops > span strong {
  display: inline-block;
  margin-right: 7px;
  vertical-align: middle;
}

.layout-cont .top-3 .tops > span img {
  width: 55px;
  height: 28px;
  vertical-align: middle;
  opacity: 0.3;
}

.layout-cont .top-3 .tops .u-name {
  font-size: 22px;
  color: #fff;
  padding: 18px 0 10px 28px;
}

.layout-cont .top-3 .tops .u-time {
  margin-left: 28px;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
  border-radius: 15px;
  display: inline-block;
  padding: 0 10px;
}

.layout-cont .list-c {
  width: 100%;
  /* padding: 0 95px; */
  overflow: hidden;
}

.layout-cont .list-c .list {
  width: 100%;
  height: 49px;
  line-height: 34px;
  padding-bottom: 15px;
  margin-top: 15px;
  border-bottom: 1px solid #f5f5f5;
  clear: both;
}

.layout-cont .list-c .list-th,
.layout-cont .list-c .list:last-child {
  border-bottom: 0;
}

.layout-cont .list-c .list > div {
  float: left;
  font-size: 20px;
  color: #424242;
}

.layout-cont .list-c .list-th > div {
  font-size: 22px;
  font-weight: 700;
}

.layout-cont .list-c .list .list1 {
  width: 50px;
  margin: 0 30px;
}

.layout-cont .list-c .list .list2 {
  width: 420px;
  margin: 0 80px;
}

.layout-cont .list-c .list .list3 {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 60px;
  text-align: center;
}

.layout-cont .list-c .list .list1 .list-num {
  width: 34px;
  height: 34px;
  line-height: 34px;
  margin: 0 auto;
  border-radius: 50%;
  background: #efefef;
  color: #999;
  text-align: center;
}

.layout-cont .list-c .list.num1 .list-num,
.layout-cont .list-c .list.num2 .list-num,
.layout-cont .list-c .list.num3 .list-num {
  background-image: url(../../assets/imgs/rank-icon.png);
  background-color: transparent;
  width: 23px;
  height: 33px;
  border-radius: 0;
  margin: 0 13px;
}

.layout-cont .list-c .list.num1 .list-num {
  background-position: 0 -3px;
}

.layout-cont .list-c .list.num2 .list-num {
  background-position: -28px -3px;
}

.layout-cont .list-c .list.num3 .list-num {
  background-position: -56px -3px;
}

.layout-cont .list-c .list .list2 .u-Img {
  display: block;
  float: left;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 20px;
}

.layout-cont .list-c .list .list2 .u-Name {
  float: left;
  max-width: 185px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
  color: #666;
  text-align: left;
}

.layout-cont .list-c .list .list3 .u-Time {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.layout-cont .list-c .list .list3 strong {
  font-size: 24px;
  color: #f2465e;
}
.layout-cont .d-bInfo {
  width: 100%;
  background: #f7f8fa;
  border-radius: 5px;
  margin-bottom: 22px;
}

.layout-cont .d-bInfo dl {
  float: left;
  margin-top: 20px;
  margin-left: 30px;
}

.layout-cont .d-bInfo dt {
  float: left;
  width: 36px;
  margin-right: 15px;
}

.layout-cont .d-bInfo dt img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.layout-cont .d-bInfo dd {
  float: left;
}

.layout-cont .d-bInfo dd h5 {
  font-size: 20px;
  color: #666;
  font-weight: normal;
  line-height: 33px;
  margin-bottom: 15px;
}

.layout-cont .d-bInfo dd h5 strong {
  color: #333;
  font-weight: normal;
  margin-right: 24px;
}

.layout-cont .d-bInfo dd p {
  font-size: 20px;
  color: #666;
}

.layout-cont .d-bInfo .quick_study {
  float: right;
  width: 174px;
  height: 40px;
  text-align: center;
  font-size: 18px;
  border-radius: 5px;
  margin: 40px 30px 39px 0;
  background-color: #409eff;
  color: #ffffff;
  line-height: 40px;
}

.rank-content >>> .rank-tabs {
  width: 450px;
  margin: 20px auto 0;
  box-shadow: none;
  background: #eaeaea;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: none;
}
.rank-content >>> .rank-tabs /deep/ .el-tabs__header {
  border: none;
  background: #eaeaea;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.rank-content >>> .rank-tabs /deep/ .el-tabs__content {
  padding: 0;
  display: none;
}
.rank-content >>> .el-tabs__item {
  height: 62px;
  width: 150px;
  font-size: 24px;
  font-weight: bold;
  line-height: 62px;
  /* border-right: 2px solid #dcdfe6; */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
}
.rank-content >>> .el-tabs__item.is-active {
  border: 1px solid transparent;
  box-sizing: border-box;
  color: #000000;
}
.rank-content >>> .el-tabs__item.is-active i {
  display: inline-block;
  width: 31px;
  height: 62px;
  background: url("../../assets/imgs/trophy.png") no-repeat center;
  background-size: 22px;
  margin-right: 0;
  vertical-align: middle;
  position: absolute;
  left: 15px;
}
.rank-content .el-pagination {
  text-align: center;
}
.rank-content .el-pagination /deep/ button {
  height: 35px;
  width: 35px;
}
.rank-content .el-pagination /deep/ .el-pager li {
  height: 35px;
  width: 35px;
  line-height: 35px;
}
.rank-content .el-pagination /deep/ .el-pagination__total {
  height: 35px;
  line-height: 35px;
}
.no-data {
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
